import { render } from "./SystemSettingsStatus.vue?vue&type=template&id=8ef59adc&scoped=true&ts=true"
import script from "./SystemSettingsStatus.vue?vue&type=script&lang=ts"
export * from "./SystemSettingsStatus.vue?vue&type=script&lang=ts"

import "./SystemSettingsStatus.vue?vue&type=style&index=0&id=8ef59adc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef59adc"]])

export default __exports__